import { useContext } from "react";
import { DisplayOptionContext } from "@/context/displayOptionContext";

export const useDisplayOptionContext = () => {
    const context = useContext(DisplayOptionContext);
    if (!context) {
        throw new Error('useDisplayOptionContext must be used within a DisplayOptionContext.Provider');
    }
    return context;
}